export const DEFAULT_STUDIO_ASPECT_RATIO = '16:9';

export const STUDIO_ASPECT_RATIOS = [
  { value: '16:9', label: '16:9' },
  { value: '9:16', label: '9:16' },
  { value: '1:1', label: '1:1' },
  { value: '4:5', label: '4:5' },
  { value: '3:4', label: '3:4' },
];

export function normalizeStudioAspectRatio(value: unknown) {
  return STUDIO_ASPECT_RATIOS.some(option => option.value === value)
    ? String(value)
    : DEFAULT_STUDIO_ASPECT_RATIO;
}

export function studioAspectRatioToCss(value: string) {
  const [width, height] = normalizeStudioAspectRatio(value).split(':').map(Number);
  return `${width} / ${height}`;
}

export function studioAspectRatioNumber(value: string) {
  const [width, height] = normalizeStudioAspectRatio(value).split(':').map(Number);
  return width / height;
}
